<template>
	<dialog-component custom-class="login-wrap" @close="onClose">
		<p class="login-title">Хотите продолжить?</p>
		<p class="login-description">
			Войдите, чтобы генерировать изображения, музыку, получать эмоциональную поддержку и сохранять историю
		</p>
		<div class="login-btn-group">
			<base-button text="Войти" @click="onLogin" />
			<base-button text="Продолжить без входа" variant="secondary" @click="onClose" />
		</div>
	</dialog-component>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import DialogComponent from '@/components/dialogs/DialogComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useCommonStore } from '@/stores/common'
import { redirectToAuth } from '@/utils/authRedirect'
import AppConfig from '@/config'

const commonStore = useCommonStore()
const router = useRouter()

function onClose() {
	commonStore.closeLoginModal()
}

function onLogin() {
	commonStore.closeLoginModal()
	// Своя страница входа есть только в b2c + internal; иначе вход на внешнем auth-сервисе.
	if (AppConfig.internalB2C) {
		router.push('/login')
		return
	}
	if (!redirectToAuth()) router.push('/')
}
</script>

<style lang="scss" scoped>
.login {
	&-title {
		font: var(--font-title);
		color: var(--text-primary);
		text-align: center;
		margin-bottom: 12px;
	}
	&-description {
		font: var(--font-body-small);
		color: var(--text-secondary);
		text-align: center;
		margin-bottom: 24px;
	}
	&-btn-group {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
		// перебиваем padding: 15px 20px из .btn в BaseButton
		.btn {
			padding: 14px 12px;
		}
	}
}
</style>
